import React from "react";
import { useVariantCopy } from "./useVariantCopy";

// Lifted out of variant/Testimonials so it can sit under the pricing cards —
// the "why bother" argument lands better right after the visitor sees a price.
const WhyFollowers = () => {
  const L = useVariantCopy();

  return (
      <section className="stripe-section stripe-section--gradient">
        <div className="mx-auto px-4 text-center stripe-container">
          <span className="text-instagram stripe-label">{L.testimonials.whyLabel}</span>
          <h2 className="mt-3 stripe-heading stripe-heading--md">
            {L.testimonials.whyHeading}
          </h2>
          <p className="mt-2 mx-auto mb-5 stripe-body stripe-body--md" style={{ maxWidth: '460px' }}>
            {L.testimonials.whySub}
          </p>

          <div className="grid md:grid-cols-3 gap-6" style={{ maxWidth: '960px', margin: '0 auto' }}>
            {[
              { icon: 'fas fa-handshake' },
              { icon: 'fas fa-link' },
              { icon: 'fas fa-chart-line' },
            ].map((card, i) => (
              <div
                key={i}
                className="text-center"
                style={{ background: '#fff', border: '1px solid #e8ecf1', borderRadius: '20px', padding: '2rem 1.75rem' }}
              >
                <div className="d-inline-flex align-items-center justify-content-center mb-3" style={{ width: '48px', height: '48px', borderRadius: '14px', background: 'linear-gradient(135deg, #fce7f3 0%, #f0ebff 100%)' }}>
                  <i className={`${card.icon} text-instagram`} style={{ fontSize: '1.1rem' }}></i>
                </div>
                <h3 className="stripe-heading stripe-heading--xs" style={{ marginBottom: '0.5rem' }}>{L.testimonials.whyCards[i].title}</h3>
                <p className="mb-0 stripe-body stripe-body--sm">{L.testimonials.whyCards[i].desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
  );
};

export default WhyFollowers;
